module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/playlist-2-967474a344270c3aa5c5f26f9fd68400.svg";